const FormTheme = {
  formField: {
    label: {
      color: "dark-2",
      size: "small",
      margin: { vertical: "0", bottom: "small", horizontal: "0" }
    },
    border: 0
  },
  global: {
    input: {
      weight: 500,
      padding: "10px"
    },
    focus: {
      border: {
        color: "#9B9B9B"
      }
    }
  },
  textInput: {
    extend: {
      boxShadow: "none",
      background: "white"
    }
  },
  textArea: {
    extend: {
      boxShadow: "none",
      background: "white"
    }
  },
  select: {
    extend: {
      boxShadow: "none"
    }
  },
  radioButton: {
    gap: "medium",
    size: "14px",
    hover: {
      border: {
        color: "dark-3"
      }
    },
    check: {
      color: {
        light: "dark-1"
      }
    },
    icon: {
      size: "8px"
    }
  }
};

export default FormTheme;
